// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LangAndCurrency_wrapper__3T3CC","currency":"LangAndCurrency_currency__2RZ7o"};